import { Component, Input } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { NewSpinnerComponent } from '../new-spinner/new-spinner.component';
import { DefaultLayoutAlignDirective, DefaultLayoutDirective } from 'ng-flex-layout';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-loading',
  styleUrls: ['./loading.component.scss'],
  templateUrl: './loading.component.html',
  standalone: true,
  imports: [
    NewSpinnerComponent,
    DefaultLayoutDirective,
    DefaultLayoutAlignDirective,
    NgIf,
  ],
})
export class LoadingComponent{
  @Input() public loading = true;
  @Input() public loadingError: boolean;
  @Input() public local: boolean;

  constructor() {}

}
